/** @format */

export let idmURL;
export let apiUrl;
export let robnoUrl;
export let syncUrl;
switch (process.env.REACT_APP_ENV) {
  case "Dev":
    idmURL = "http://afb.northeurope.cloudapp.azure.com:83/api/v1/Auth";
    //apiUrl = "https://localhost:5001/api/v1";
    apiUrl = "http://afb.northeurope.cloudapp.azure.com:81/api/v1";
    //robnoUrl = "https://localhost:44364/api/v1";
    robnoUrl = "http://afb.northeurope.cloudapp.azure.com:84/api/v1";
    break;
  case "Robno":
    idmURL = "http://afb.northeurope.cloudapp.azure.com:93/api/v1/Auth";
    apiUrl = "http://afb.northeurope.cloudapp.azure.com:91/api/v1";
    robnoUrl = "http://afb.northeurope.cloudapp.azure.com:94/api/v1";
    break;
  case "Test":
    idmURL = "https://afbtest.telekomcloud.hr/idm/api/v1/auth";
    apiUrl = "https://afbtest.telekomcloud.hr/portalapi/api/v1";
    robnoUrl = "https://afbtest.telekomcloud.hr/robno/api/v1";
    break;
  case "PreProd":
    idmURL = "https://afbtest.telekomcloud.hr/idmprod/api/v1/auth";
    apiUrl = "https://afbtest.telekomcloud.hr/portalapiprod/api/v1";
    robnoUrl = "https://afbtest.telekomcloud.hr/robno/api/v1";
    break;
  case "Prod":
    idmURL = "https://premiumfb.telekomcloud.hr/idm/api/v1/Auth";
    apiUrl = "https://premiumfb.telekomcloud.hr/portalapi/api/v1";
    robnoUrl = "https://premiumfb.telekomcloud.hr/robno/api/v1";
    syncUrl = "https://premiumfb.telekomcloud.hr/sync/api/v10";
    break;
  default:
    idmURL = "http://afb.northeurope.cloudapp.azure.com:83/api/v1/Auth";
    apiUrl = "http://afb.northeurope.cloudapp.azure.com:81/api/v1";
    robnoUrl = "http://afb.northeurope.cloudapp.azure.com:84/api/v1";
}
export const loginURL = `${idmURL}/login`;
export const forgotPswURL = `${idmURL}/forget-password`;
export const usersURL = `${apiUrl}/user`;
export const tenantURL = `${apiUrl}/Tenant`;
export const tenantSettingURL = `${apiUrl}/TenantSetting`;
export const storeURL = `${apiUrl}/Store`;
export const ramUsageURL = `${apiUrl}/Dashboard/ram-usage`;
export const memoryUsageURL = `${apiUrl}/Dashboard/memory-usage`;
export const priceListUrl = `${apiUrl}/PriceList`;
export const posUrl = `${apiUrl}/Pos`;
export const languageUrl = `${apiUrl}/Language`;
export const itemGroupUrl = `${apiUrl}/ItemGroup`;
export const itemUrl = `${apiUrl}/Item`;
export const globalUrl = `${apiUrl}/Global`;
export const lastActivatedPosURL = `${apiUrl}/Dashboard/last-activated-pos`;
export const partnerUrl = `${apiUrl}/Partner`;
export const taxRateUrl = `${apiUrl}/TaxRate`;
export const certURL = `${apiUrl}/Certificate`;
export const payOptionUrl = `${apiUrl}/PayOption`;
export const unitOfMeasureUrl = `${apiUrl}/UnitOfMeasure`;
export const messageUrl = `${apiUrl}/Message`;
export const shiftUrl = `${apiUrl}/workhours`;
export const dashboardURL = `${apiUrl}/Dashboard`;
export const reportUrl = `${apiUrl}/Invoice/`;
export const invoiceConclusionsUrl = `${apiUrl}/InvoiceConclusion`;
export const validationURL = `${apiUrl}/Validate`;
export const newPasswordURL = `${idmURL}/recover-password`;
export const widgetURL = `${apiUrl}/Widget`;
export const logUrl = `${apiUrl}/log`;
export const documentSearchUrl = `${robnoUrl}/Document/search`;
export const documentUrl = `${robnoUrl}/Document`;

export const reportingUrl = `${robnoUrl}/Reporting`;
export const productUrl = `${robnoUrl}/Product`;
export const globalPartnerUrl = `${robnoUrl}/Global/partners`;
export const priceChangeUrl = `${robnoUrl}/PriceChange`;
export const priceChangeSearchUrl = `${robnoUrl}/PriceChange/search`;
export const retailStateUrl = `${robnoUrl}/RetailState`;
export const GlobalReceiptUrl = `${robnoUrl}/Global/receipt`;
export const inventoryUrl = `${robnoUrl}/Inventory`;
export const changePassUrl = `${idmURL}/change-password`;
export const cardUrl = `${apiUrl}/Card`;
export const tenantPaymentMethodUrl = `${apiUrl}/TenantPaymentMethod`;
export const posVersionUrl = `${apiUrl}/version`;

export const surveyUrl = `${apiUrl}/survey`;
export const supportUrl = `${apiUrl}/support`;
export const digitalContentUrl = `${apiUrl}/digital-content`;
export const migrationUrl = `${apiUrl}/migration`;
export const rawMaterialUrl = `${apiUrl}/Normative/rawMaterials`;
export const normativeUrl = `${apiUrl}/Normative`;

export const fiscalUrl=`${syncUrl}/fiscal/auto`;
export const ediFiscalUrl=`${syncUrl}/fiscal/edi`;
